export default __webpack_public_path__ + "static/media/proprietarios-assessoria-image-centro.695bf049.webp";